(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("moment"));
	else if(typeof define === 'function' && define.amd)
		define(["moment"], factory);
	else if(typeof exports === 'object')
		exports["vue-monthly-picker"] = factory(require("moment"));
	else
		root["vue-monthly-picker"] = factory(root["moment"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_12__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition